import { FileText } from "lucide-react";
import { EmptyState } from "@/components/empty-state";

export default function DocumentsTab() {
  return (
    <EmptyState
      icon={FileText}
      title="Documents are coming"
      body="Boarding passes, reservations, and IDs — one shared folder per trip. Coming after v2 launch."
    />
  );
}
